export const SUBMISSION_STATUS = [
  { label: 'All', value: 'ALL' },
  { label: 'Waiting For Approval', value: 'PENDING' },
  { label: 'Approved', value: 'ACCEPTED' },
  { label: 'Declined', value: 'REJECTED' },
];

export const PLAN = [
  { label: 'Unlimited', value: 'UNLIMITED' },
  { label: 'Radio', value: 'RADIO' },
];

export const GRAPH_FILTER = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'HALF_YEARLY', label: 'Half Yearly' },
  { value: 'START_YEAR', label: 'Start Year' },
  { value: 'YEARLY', label: 'Yearly' },
];
